import { makeAutoObservable } from "mobx";
import ApiStore from "../ApiStore";
import {CommunityAdditionalContact, ContactsAndLinksItem } from "../../../api/Association/AssociationTypes";

class ContactsAndLinksStore {
    private _api: ApiStore;

    constructor(api: ApiStore) {
        makeAutoObservable(this);
        this._api = api;
    }

    public async getContactsAndLinks(): Promise<ContactsAndLinksItem> {
        return this._api.AssociationApiClient.getContactsAndLinks();
    }
     public async addCommunityAdditionalContact(communityAdditionalContactAdd : CommunityAdditionalContact): Promise<any> {
        return  await this._api.AssociationApiClient.addCommunityAdditionalContact(communityAdditionalContactAdd);
    }

    public async updateCommunityAdditionalContact(CommunityAdditionalContactUpdates : CommunityAdditionalContact[]): Promise<any> {
        return  await this._api.AssociationApiClient.updateCommunityAdditionalContact(CommunityAdditionalContactUpdates);
    }

     public async deleteCommunityAdditionalContact(communityAdditionalContactDelete : CommunityAdditionalContact[]): Promise<any> {
        return await this._api.AssociationApiClient.deleteCommunityAdditionalContact(communityAdditionalContactDelete);
    }
}
export default ContactsAndLinksStore